"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_2 = require("react");
const Loading_1 = __importDefault(require("./Loading"));
const Snackbar_1 = __importDefault(require("./Snackbar"));
const react_router_dom_1 = require("react-router-dom");
function Dashboard({ navbar, user, dashboardPanel, dashboardRoutes, snackbar, noTrans, bg, defaultRoute, }) {
    const [loading, setLoading] = react_2.useState(true);
    const { pathname } = react_router_dom_1.useLocation();
    react_2.useEffect(() => {
        if (user && user.token)
            setLoading(false);
    }, [user]);
    if (!user)
        return null;
    if (pathname === "/" && defaultRoute !== "/")
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: defaultRoute || "/users" });
    if (user.token === "noUser")
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: "/login" });
    return (react_1.default.createElement("div", { className: "has-background-neutral-light60 height-100" },
        snackbar &&
            snackbar.map((snack, i) => (react_1.default.createElement(Snackbar_1.default, { type: snack.type, msg: snack.msg, close: () => snack.close(), key: i, noTrans: noTrans }))),
        react_1.default.createElement("div", { className: "columns m-0 height-100" },
            dashboardPanel,
            react_1.default.createElement("div", { className: "column  p-0 height-100" },
                navbar,
                react_1.default.createElement("div", { className: `${bg || "has-background-white"} is-full-width overflow-y-auto dashboard is-relative` }, loading ? (react_1.default.createElement("div", { className: "min-height100 is-flex is-align-items-center is-justify-content-center" },
                    react_1.default.createElement(Loading_1.default, { noTrans: noTrans }))) : (dashboardRoutes))))));
}
exports.default = Dashboard;
//# sourceMappingURL=Dashboard.js.map